import { API_ROUTES } from "../constants";
import { STRAPI_URL } from "../env";

/**
 * Whether the chatbot feature flag is enabled on the backend. Fails closed,
 * so the chatbot stays hidden whenever the status can't be determined.
 */
export async function fetchChatbotStatus(): Promise<boolean> {
  try {
    const response = await fetch(
      `${STRAPI_URL.replace(/\/$/, "")}/${API_ROUTES.CHAT_STATUS}`,
      {
        credentials: "include",
        cache: "no-store",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status >= 400) {
      return false;
    }

    const json = (await response.json()) as { data?: { enabled?: boolean } };
    return json.data?.enabled === true;
  } catch {
    return false;
  }
}
